// This storage is used to save document transaction data
import { StateCreator } from 'zustand';
import { SIGNATURE_REQUEST_EXPIRATION } from '../../constants';
import {
	Account,
	BaseFiles,
	DocumentTransaction,
	DocumentTransactionRequest,
	ExtendedRSDocument,
	Role,
	SignatureSettings,
} from '../../data/rsTypes';
import { storeResetFns } from '.';

type State = {
	document_transaction: DocumentTransaction;
	rsDocument?: ExtendedRSDocument;
	accounts?: Account[];
	base_files?: BaseFiles[];
	roles?: Role[];
	documentSignatureSettings?: SignatureSettings;
};

type Actions = {
	setDocumentTransaction: (documentTransaction: DocumentTransactionRequest) => void;
	updateRSDocument: (data: Partial<ExtendedRSDocument> | ExtendedRSDocument) => void;
	updateDocumentSignatureSettings: (
		documentSignatureSettings: Partial<SignatureSettings> | SignatureSettings
	) => void;
	resetDocumentSignatureSettings: () => void;
	updateDocumentTransaction: (data: Partial<DocumentTransaction>) => void;
};

export type DocumentTransactionStore = State & Actions;

const initialState: State = {
	document_transaction: null,
	rsDocument: null,
	accounts: null,
	base_files: null,
	roles: null,
	documentSignatureSettings: {
		expiresInDays: SIGNATURE_REQUEST_EXPIRATION.DEFAULT,
	},
};

export const createDocumentTransactionSlice: StateCreator<DocumentTransactionStore> = (
	set,
	get
) => {
	storeResetFns.add(() => {
		set(initialState);
	});
	return {
		...initialState,
		setDocumentTransaction(data: DocumentTransactionRequest) {
			set(() => ({
				document_transaction: data.document_transaction,
				base_files: data.base_files,
				rsDocument: data.documents?.[0],
				accounts: data.accounts,
				roles: data.roles,
			}));
		},
		updateRSDocument(data: Partial<ExtendedRSDocument> | ExtendedRSDocument) {
			const rsDocument = get().rsDocument;
			set(() => ({
				rsDocument: { ...rsDocument, ...data },
			}));
		},
		updateDocumentSignatureSettings(
			data: Partial<SignatureSettings> | SignatureSettings
		) {
			const documentSignatureSettings = get().documentSignatureSettings || {};
			set(() => ({
				documentSignatureSettings: {
					...documentSignatureSettings,
					...data,
				},
			}));
		},
		resetDocumentSignatureSettings() {
			set(() => ({
				documentSignatureSettings: {
					expiresInDays: SIGNATURE_REQUEST_EXPIRATION.DEFAULT,
				},
			}));
		},
		updateDocumentTransaction(data: Partial<DocumentTransaction>) {
			const documentTransaction = get().document_transaction;
			set(() => ({
				document_transaction: { ...documentTransaction, ...data },
			}));
		},
	};
};
